'use strict';

var _ = require('lodash');
var ProfileChartFlightCardController = function ProfileChartFlightCardController($scope, $filter) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.$watch('entity', updateEntityInfo);
  function updateEntityInfo(entity) {
    if (_.isUndefined(entity)) {
      return;
    }
    $scope.label = entity.label || buildLabel(entity);
    $scope.additionalInfo = entity.additionalInfo || buildAdditionalInfoLabel(entity);
  }
  function buildLabel(entity) {
    var copy = _.assign({}, entity);
    return [copy.flightNumber, copy.leg, rmMomentFormat(copy.legDepartureDateMoment, 'DATE_USER_SETTINGS')].join(' ');
  }
  function buildAdditionalInfoLabel(entity) {
    var copy = _.assign({}, entity);
    return copy.cabinCode + ': LCA ' + (copy.lca || 'N/A') + ' (' + rmNumberFormat(copy.segClassFare || copy.segClassMappedFare || 'N/A', 'CURRENCY_NO_DECIMAL') + ')' + " \xB7 Avail: " + (copy.effAvail || 'N/A');
  }
};
ProfileChartFlightCardController.$inject = ['$scope', '$filter'];
module.exports = ProfileChartFlightCardController;